import { render } from "./AccessPassword.vue?vue&type=template&id=aa54670a"
import script from "./AccessPassword.vue?vue&type=script&lang=js"
export * from "./AccessPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__